import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AIInsights({ currency }) {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateInsights = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API}/insights`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currency })
      });

      if (response.ok) {
        const data = await response.json();
        setInsights(data.insights);
      } else {
        toast.error('Failed to generate insights');
      }
    } catch (error) {
      toast.error('Failed to generate insights');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card data-testid="ai-insights-card" className="mb-8 border border-border">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-xl sm:text-2xl tracking-tight font-semibold flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-accent" strokeWidth={1.5} />
              AI-Powered Insights
            </CardTitle>
            <CardDescription className="text-sm text-muted-foreground mt-1">
              Get personalized financial recommendations
            </CardDescription>
          </div>
          <Button
            data-testid="generate-insights-button"
            onClick={generateInsights}
            disabled={loading}
            className="transition-transform duration-200 hover:-translate-y-px"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Analyzing...
              </>
            ) : (
              <>
                <Sparkles className="mr-2 h-4 w-4" />
                Generate Insights
              </>
            )}
          </Button>
        </div>
      </CardHeader>
      {insights && (
        <CardContent className="p-6">
          <div className="p-4 bg-accent/5 border border-accent/20 rounded-md">
            <p className="text-base leading-relaxed whitespace-pre-wrap">{insights}</p>
          </div>
        </CardContent>
      )}
    </Card>
  );
}

export default AIInsights;